import * as React from 'react';
import { IProjectItemProps } from './IProjectItem';
import { useTranslation } from 'react-i18next';
import { EProjectType } from '../../../../enum/project';

const ProjectItem = (props: IProjectItemProps) => {
    const { t, i18n } = useTranslation();
    let type;
    if (props.project.type === EProjectType.Macra1) type = t('project_type_protection');
    else type = t('project_type_structure');
    let options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' };
    let date = new Date(props.project.date).toLocaleDateString(i18n.language, options);
    return (
        <>
            <div className='d-flex justify-content-between p-1 cursor-pointer'>
                <div className='w-100 d-flex' onClick={props.onClick}>
                    <div className='w-30 me-5 ellipsis-simple-line' title={props.project.name}>
                        {props.project.name}
                    </div>
                    <div className='w-30 me-5'>{date}</div>
                    <div className='w-30'>{type}</div>
                </div>
                <i className='fa-solid fa-trash' style={{ alignSelf: 'center' }} onClick={props.onDelete} />
            </div>
            <hr />
        </>
    );
};

export default ProjectItem;
